import 'graphql-request';
import { print } from 'graphql';
import gql from 'graphql-tag';
export const GetOccupancyCurrentDocument = gql `
    query getOccupancyCurrent($fromDate: DateTime!, $toDate: DateTime!, $buildingCode: String!, $endOfPreviousDay: DateTime!) {
  building(code: $buildingCode) {
    capacity
    totalOccupancy(fromDate: $fromDate, toDate: $toDate) {
      tenant {
        count
        name
      }
      staff {
        count
        name
      }
      visitor {
        count
        name
      }
    }
    thirtyDayAverageOccupancy(endOfPreviousDay: $endOfPreviousDay) {
      name
      weekday
      weekend
    }
    occupancyBySensor(fromDate: $fromDate, toDate: $toDate) {
      date
      group
      value
    }
  }
}
    `;
export const GetOccupancySensorsDocument = gql `
    query getOccupancySensors($buildingCode: String!, $startOfDay: DateTime!, $now: DateTime!, $sensorIds: [String!]!) {
  building(code: $buildingCode) {
    capacity
    anonymousTotalOccupancyByBucket(fromDate: $startOfDay, toDate: $now) {
      date
      value
    }
    occupancyBySensor(fromDate: $startOfDay, toDate: $now) {
      date
      group
      value
    }
    anonymousTotalOccupancy(fromDate: $startOfDay, toDate: $now, ids: $sensorIds)
  }
}
    `;
export const GetOccupancyTrendsDocument = gql `
    query getOccupancyTrends($fromDate: DateTime!, $toDate: DateTime!, $buildingCode: String!, $endOfPreviousDay: DateTime!) {
  building(code: $buildingCode) {
    capacity
    accessControlOccupancy(fromDate: $fromDate, toDate: $toDate)
    totalOccupancy(fromDate: $fromDate, toDate: $toDate) {
      tenant {
        count
        name
      }
      staff {
        count
        name
      }
      visitor {
        count
        name
      }
    }
    thirtyDayAverageOccupancy(endOfPreviousDay: $endOfPreviousDay) {
      name
      weekday
      weekend
    }
    anonymousTotalOccupancyByBucket(fromDate: $fromDate, toDate: $toDate) {
      date
      value
    }
  }
}
    `;
export const GetOccupantTypeCountByBucketDocument = gql `
    query getOccupantTypeCountByBucket($fromDate: DateTime!, $toDate: DateTime!, $buildingCode: String!, $includeWeekends: Boolean!) {
  building(code: $buildingCode) {
    occupantTypeCountByBucket(
      fromDate: $fromDate
      toDate: $toDate
      includeWeekends: $includeWeekends
    ) {
      bucket
      tenantCount
      visitorCount
      staffCount
    }
  }
}
    `;
export const GetTenantBreakdownByBucketDocument = gql `
    query getTenantBreakdownByBucket($buildingCode: String!, $dates: [DateTime!]!) {
  building(code: $buildingCode) {
    tenantBreakdownByBucket(dates: $dates) {
      bucket
      breakdown {
        tenants {
          name
          count
        }
        visitors {
          name
          count
        }
        staff {
          name
          count
        }
      }
    }
  }
}
    `;
export const GetTenantBreakdownSummedDocument = gql `
    query getTenantBreakdownSummed($buildingCode: String!, $fromDate: DateTime!, $toDate: DateTime!, $includeWeekends: Boolean!) {
  building(code: $buildingCode) {
    tenantBreakdownSummed(
      fromDate: $fromDate
      toDate: $toDate
      includeWeekends: $includeWeekends
    ) {
      tenants {
        name
        count
      }
      visitors {
        name
        count
      }
      staff {
        name
        count
      }
    }
  }
}
    `;
export const GetTotalOccupantCountByBucketDocument = gql `
    query getTotalOccupantCountByBucket($buildingCode: String!, $dates: [DateTime!]!) {
  building(code: $buildingCode) {
    totalOccupantCountByBucket(dates: $dates) {
      bucket
      count
    }
  }
}
    `;
const defaultWrapper = sdkFunction => sdkFunction();
export function getSdk(client, withWrapper = defaultWrapper) {
    return {
        getOccupancyCurrent(variables, requestHeaders) {
            return withWrapper(() => client.request(print(GetOccupancyCurrentDocument), variables, requestHeaders));
        },
        getOccupancySensors(variables, requestHeaders) {
            return withWrapper(() => client.request(print(GetOccupancySensorsDocument), variables, requestHeaders));
        },
        getOccupancyTrends(variables, requestHeaders) {
            return withWrapper(() => client.request(print(GetOccupancyTrendsDocument), variables, requestHeaders));
        },
        getOccupantTypeCountByBucket(variables, requestHeaders) {
            return withWrapper(() => client.request(print(GetOccupantTypeCountByBucketDocument), variables, requestHeaders));
        },
        getTenantBreakdownByBucket(variables, requestHeaders) {
            return withWrapper(() => client.request(print(GetTenantBreakdownByBucketDocument), variables, requestHeaders));
        },
        getTenantBreakdownSummed(variables, requestHeaders) {
            return withWrapper(() => client.request(print(GetTenantBreakdownSummedDocument), variables, requestHeaders));
        },
        getTotalOccupantCountByBucket(variables, requestHeaders) {
            return withWrapper(() => client.request(print(GetTotalOccupantCountByBucketDocument), variables, requestHeaders));
        }
    };
}
